import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import logo from "../../Assets/images/q-nexus.png";
import loginArt from "../../Assets/images/login-bg.png";

const SetPassword = () => {
    const d = useDispatch();
    const navigate = useNavigate();
    const {token} = useParams()
    const [password, setPassword] = useState("");
    const [show, setShow] = useState(false);

    console.log(token , 'token')

    const submitPassword = async () => {
        if (!password) return toast.error("Password is required");
        if (!token) return toast.error("Invalid or missing token");

        d(loadingTrue());
        const r = await Handler({
            method: "post",
            url: "/auth/activate_account.php",
            data: { token, password }
        });

        if (r?.success) {
            toast.success("Password set successfully");
            navigate("/login");
        } else {
            toast.error(r?.message || "Something went wrong");
        }
        d(loadingFalse());
    };

    return (
        <div className="login-page">
            <div className="login-header">
                <img src={logo} className="login-logo" alt="logo" />
            </div>

            <div className="login-center">
                <div className="login-card card">
                    <h2 className="login-title text-center">Set New Password</h2>

                    <label>New Password *</label>
                    <div className="position-relative mb-4">
                        <input
                            type={show ? "text" : "password"}
                            className="form-control pe-5"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Enter new password"
                        />
                        <i
                            className={`fa ${show ? "fa-eye-slash" : "fa-eye"} position-absolute`}
                            style={{ right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                            onClick={() => setShow(!show)}
                        ></i>
                    </div>

                    <button className="btn login-btn w-100" onClick={submitPassword}>
                        Update Password
                    </button>
                </div>
            </div>

            <div className="login-art-wrap d-none d-lg-block">
                <img src={loginArt} alt="art" />
            </div>
        </div>
    );
};

export default SetPassword;
